export const comicActionTypes = {
  FETCH_COMICS_REQUEST: 'FETCH_COMICS_REQUEST',
  FETCH_COMICS_SUCCESS: 'FETCH_COMICS_SUCCESS',
  FETCH_COMICS_FAILURE: 'FETCH_COMICS_FAILURE',

  ADD_COMIC_REQUEST: 'ADD_COMIC_REQUEST',
  ADD_COMIC_SUCCESS: 'ADD_COMIC_SUCCESS',
  ADD_COMIC_FAILURE: 'ADD_COMIC_FAILURE',

  EDIT_COMIC_REQUEST: 'EDIT_COMIC_REQUEST',
  EDIT_COMIC_SUCCESS: 'EDIT_COMIC_SUCCESS',
  EDIT_COMIC_FAILURE: 'EDIT_COMIC_FAILURE',

  DELETE_COMICS_REQUEST: 'DELETE_COMICS_REQUEST',
  DELETE_COMICS_SUCCESS: 'DELETE_COMICS_SUCCESS',
  DELETE_COMICS_FAILURE: 'DELETE_COMICS_FAILURE',
}

export const comicActions = {
  fetchComics: (payload, callback) =>
  ({
    type: comicActionTypes.FETCH_COMICS_REQUEST,
    payload,
    callback
  }),
  addComic: (payload, callback) =>
  ({
    type: comicActionTypes.ADD_COMIC_REQUEST,
    payload,
    callback
  }),
  editComic: (payload, callback) =>
  ({
    type: comicActionTypes.EDIT_COMIC_REQUEST,
    payload,
    callback
  }),
  deleteComics: (payload, callback) =>
  ({
    type: comicActionTypes.DELETE_COMICS_REQUEST,
    payload,
    callback
  }),
};

export default comicActions;